import { render, staticRenderFns } from "./LoyaltyBonusCard.vue?vue&type=template&id=14139ba7&"
import script from "./LoyaltyBonusCard.vue?vue&type=script&lang=js&"
export * from "./LoyaltyBonusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports